import { ChemicalComponent } from "@/services/chemical-component"
import { Button, Col, Form, Input, InputNumber, Row, Space } from "antd"
import { useEffect } from "react"


export const GeneralForm = (props: {
  component?: ChemicalComponent.Modal,
  onSave: (val) => void
  onCancel?: Function
}) => {
  const {onSave, onCancel, component}= props
  const [form] = Form.useForm()

  useEffect(() => {
    if (component) {
      form.setFieldsValue(component)
    }
  }, [component, form])
  
  return <Form
    form={form}
    onFinish={(values) => {
      onSave(values)
    }}
    className="mt-4"
  >
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='pc'
          label='Pc(MPa)'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='tc'
          label='Tc(K)'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='af'
          label='Acentric Factor'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='mw'
          label='Mol Weight(g/mol)'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='hf0Gas'
          label='ΔfH°gas(kJ/mol)'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
          name='sf0Gas'
          label='S°gas(kJ/mol.K)'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='hf0Liq'
          label='ΔfH°liq(kJ/mol)'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
          name='sf0Liq'
          label='S°liq(kJ/(mol.K))'
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>

    <Row justify={'end'}>
      <Space>
        <Button htmlType="button" onClick={() => onCancel?.()}>Cancel</Button>
        <Button type="primary" htmlType="submit">Save</Button>
      </Space>
    </Row>
    
  </Form>
}